import { FLAG_NAMES, ROUTES } from '@router/modules/constants'

const hasFlag = (routeName, flag) => {
  const routeObject = Object.values(ROUTES).find(route => route.name === routeName)

  if (!routeObject) {
    return false
  }

  return routeObject.flags?.[flag] === true
}

export const isPublicPage = (routeName) => {
  return hasFlag(routeName, FLAG_NAMES.IS_PUBLIC_PAGE)
}

export const isSignInSignUpPage = (routeName) => {
  return hasFlag(routeName, FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE)
}
